import React, { Component } from 'react';
import './PlotSearch.css';
import CheckboxFilter from './CheckboxFilter';
import MenuType from '../enums/MenuType';
import Option from '../choices/Option';
import Once from '../core/Once';
import SubMenuHeader from './SubMenuHeader';
import NumericalKeyboard from './NumericalKeyboard';
import ClickedOffManager from '../ui_core/ClickedOffManager';
export default class PlotSearch extends Component {
	static get _MAX_LENGTH(){
		return 5;
	}
	constructor(props){
		super(props);
		const {bedroomsFilterSettings, selectedPlot, onSelectedOptionsChange}=props;
		this._callbackSelectedPlot=selectedPlot;
		this._selectedOptionsChangedOnce = new Once(onSelectedOptionsChange);
		this._checkboxFilter=React.createRef();
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this._input = React.createRef();
		this._options = [];
		this.load = this.load.bind(this);
		this._iMenuManager  = null;
		this.show = this.show.bind(this);
		this.clear = this.clear.bind(this);
		this.hide= this.hide.bind(this);
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
		this._iMenuManager  = null;
		this._handleInput = this._handleInput.bind(this);
		this._handleKey= this._handleKey.bind(this);
		this._allowedKeyCodes=[8, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57]
		this._units = null;
		this.state = {options:[], visible:false, plotNumberStr:'', numberValid:true};
		this._clickedOffHandle=null;
	}
	get isApplied(){
		return this._selectedPlot?true:false;
	}
	filterPlots(plotsArray){
		if(this._selectedPlot)
			return plotsArray.filter(plot=>this._selectedPlot ===plot);
		return plotsArray;
	}
	show(){
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		if(this._callbackClose){
			this._callbackClose();
			this._callbackClose=null;
		}
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	get menuType(){
		return MenuType.PLOT_SEARCH;
	}
	load(units){
		this._units = units;
		this.clear();
	}
	clear(){
		if(this._selectedOptionsChangedOnce.triggered)return;
		this.setState({plotNumberStr:''});
		this._selectedPlot = null;
	}
	_handleInput(e){
		e=e.nativeEvent;
		switch(e.inputType){
			case 'deleteContentBackward':
				this._handleKey(8);
				break;
			case 'insertText':
				this._handleKey(e.data.charCodeAt(0));
				break;
		}
	}
	_handleKey(keyCode){
		const allowedKey =  this._allowedKeyCodes.indexOf(keyCode)>=0;
		if(!allowedKey)
			return;
		let plotNumberStr=this.state.plotNumberStr;
		if(plotNumberStr===null)plotNumberStr='';
		if(keyCode===8){
			if(plotNumberStr.length<1)return;
			plotNumberStr = plotNumberStr.substring(0, plotNumberStr.length-1);
		}
		else
		{
			const hasSpace = this.state.plotNumberStr.length<PlotSearch._MAX_LENGTH;
			if(!hasSpace)return;
			plotNumberStr+=String.fromCharCode(keyCode);
		}
		const plotNumber = plotNumberStr.length>0?parseInt(plotNumberStr):null;
		const plot = plotNumber===null?null:this._units.getPlotByNumber(plotNumber);
		const plotValidAndNotAffordable=(plot!==undefined&&plot!==null)&&(!plot.affordable);
		const numberValid = (plotNumberStr==='')||plotValidAndNotAffordable;
		this.setState({plotNumberStr:plotNumberStr, numberValid:numberValid});
		this._callbackSelectedPlot(plotValidAndNotAffordable?plot:null);
		const previousSelectedPlot = this._selectedPlot;
		if(plotValidAndNotAffordable){
			this._selectedPlot = plot;
		}
		else{
			this._selectedPlot = null;
		}
		if(previousSelectedPlot!==this._selectedPlot)
			this._selectedOptionsChangedOnce.trigger();
	}
	render() {
		let className = "plot-search menu";
		if(this.state.visible)
			className+= " visible";
		let classNamePlotNumber ='plot-number';
		classNamePlotNumber+=this.state.numberValid?" valid":" invalid";
		return (<div className={className} ref={this._element}>
					<SubMenuHeader ref={this._subMenuHeader}></SubMenuHeader>
					<div className={classNamePlotNumber}>
						<div className="text">Plot</div>
						<input ref={this._input} type="text" className="value" onInput={this._handleInput}  value={this.state.plotNumberStr} ></input>
					</div>
					<NumericalKeyboard onKey={this._handleKey}></NumericalKeyboard>
				</div>);
	}
}
